import type {RouteLocationNormalizedLoaded} from 'vue-router'

export async function useExtraServiceRuntimeData(route: RouteLocationNormalizedLoaded) {
    const searchRequest = extraServicesRuntimeStore.searchRequestFromQuery(route.query)
    if (extraServicesRuntimeStore.city.id !== searchRequest.cityId) {
        await extraServicesRuntimeStore.loadCity(searchRequest.cityId)
    }
}
